import React, { useState, useEffect, useRef } from "react";
import { Field, ErrorMessage, useField } from "formik";
import FeatherIcon from "feather-icons-react";

function FormField({
  label,
  name,
  type = "text",
  as = "input",
  options,
  placeholder,
  rows = 4,
  className,
  prefixIcon,
  radioDirection = "vertical",
  dropdownPosition = "bottom",
  onClick,
  value,
  onChange,
  groupName,
  checked,
  ...props
}) {
  const [showPassword, setShowPassword] = useState(false);
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const inputsRef = useRef([]);
  const [field, meta, helpers] = useField(name);
  const [openCategory, setOpenCategory] = useState();
  const [search, setSearch] = useState("");

  const hasError = meta.touched && meta.error;

  const inputClasses = `border px-4 ${hasError ? "!border-2 !border-red-500" : "!border-[#d2d4da] focus:ring-1 focus:ring-gray-100 focus:border-gray-100"
    } p-1 w-full bg-transparent rounded-lg 
  h-6 sm:h-6 md:h-6 lg:h-8 xl:h-10 2xl:h-12
  text-xs md:text-sm lg:text-base xl:text-lg font-normal text-[#B3B5BD]
  focus:outline-none focus:bg-transparent  `;

  const inputClasses1 = `border px-3 ${hasError ? "!border-2 !border-red-500" : "!border-[#d2d4da] focus:ring-1 focus:ring-gray-100 focus:border-gray-100"
    } bg-transparent text-[#B3B5BD] w-full rounded-lg 
   h-6 sm:h-6 md:h-6 lg:h-8 xl:h-10 2xl:h-12
  text-xs md:text-sm lg:text-base xl:text-lg font-normal
  focus:outline-none focus:bg-transparent`;

  const textareaClasses = `border px-3 ${hasError ? "!border-2 !border-red-500" : "!border-[#d2d4da]"
    } bg-transparent p-1 w-full rounded-lg 
  h-[calc(4*1rem)] lg:h-[calc(4*1.25rem)] 2xl:h-[calc(4*1.5rem)]
  text-base lg:text-base 2xl:text-lg font-normal
  resize-none overflow-hidden focus:outline-none focus:bg-transparent`;

  const checkboxClasses = `border rounded-[4px] lg:rounded-2 2xl:rounded-4 ${hasError ? "!border-2 !border-red-500" : "!border-[#d2d4da]"
    } bg-transparent w-3 h-3 md:w-4 md:h-4 mr-2 lg:w-4 lg:h-4 xl:w-5 xl:h-5 2xl:w-6 2xl:h-6
  checked:bg-blue-500 checked:border-blue-500 custom-checkbox appearance-none`;

  const radioClasses = `appearance-none rounded-full border ${hasError ? "!border-2 !border-red-500" : "!border-black"
    } w-3 h-3 md:w-4 md:h-4 lg:w-5 lg:h-5 xl:w-6 xl:h-6 2xl:w-7 2xl:h-7 gap-1
  checked:bg-blue-500 checked:border-blue-500 focus:outline-none transition-colors`;

  const labelTextClass = "text-[6px] md:text-[8px] lg:text-[10px] xl:text-xs 2xl:text-sm text-black";

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    if (as === "otp" && inputsRef.current[0]) {
      inputsRef.current[0].focus();
    }
  }, [as]);

  return (
    <div className="flex-1 relative font-poppins">
      {(as === "input" ||
        as === "select" ||
        as === "password" ||
        as === "textarea" ||
        as === "radio" ||
        as === "otp" || as === "radiobutton") && (
          <label
            className={` ${className ? className : "text-[#F3F4F8]"} flex items-center gap-1 block mb-1 md:mb-1 lg:mb-2 xl:mb-3 2xl:mb-3 text-[12px] lg:text-[13px] xl:text-[14px] 2xl:text-[14px]`}
          >
            {prefixIcon && (
              <FeatherIcon
                icon={prefixIcon}
                className="size-2 md:size-2 lg:size-3 xl:size-4 2xl:size-5 text-gray-500"
              />
            )}
            {groupName ? groupName : label}
          </label>
        )}
      {(() => {
        switch (as) {
          case "select":
            const filteredOptions = options?.filter(opt =>
              opt?.label?.toLowerCase().includes(search.toLowerCase()) ||
              opt?.value?.toLowerCase?.().includes(search.toLowerCase())
            );

            // return (
            //   <div className="relative w-full overflow-hidden">
            //     <Field as="select" name={name} id={name} className={`${inputClasses1} select-fixed appearance-none`} onFocus={() => setIsSelectOpen(true)} onBlur={() => { setIsSelectOpen(false); helpers.setTouched(true); }} >
            //       <option></option>
            //       {options.map((option) => (<option key={option.value} value={option.value} className={`bg - [#F3F4F8] / 60 text-[#282A3A]${option.value === "" ? "p-2 bg-[#282A3A] text-[#F3F4F8]" : ""}`} >
            //         {option.label} </option>))}
            //     </Field>
            //     {!isSelectOpen &&
            //       (<div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            //         <svg
            //           className={`w-4 h-4 shrink-0 text-[#d2d4da] transition-transform duration-200 ${isSelectOpen ? "rotate-180" : ""
            //             }`
            //           }
            //           fill="none"
            //           stroke="currentColor"
            //           viewBox="0 0 24 24"
            //         >
            //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
            //         </svg>
            //       </div>)} </div >);
            return (
              <div className="relative">
                {/* Selected value box */}
                <div
                  className={`${inputClasses1} flex items-center cursor-pointer bg-transparent text-[#282A3A]`}
                  onClick={() => {
                    setIsSelectOpen(!isSelectOpen);
                    setSearch("");
                  }}
                >
                  <div className="flex-1 min-w-0 pr-2">
                    <span className="truncate block text-left">
                      {options.find(opt => opt.value === field.value)?.label || placeholder || ""}
                    </span>
                  </div>

                  <svg
                    className={`w-4 h-4 shrink-0 text-[#d2d4da] transition-transform duration-200 ${isSelectOpen ? "rotate-180" : ""}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </div>


                {/* Dropdown Panel */}
                {isSelectOpen && (
                  <div className={`
      absolute w-full bg-white border border-[#d2d4da] rounded-lg shadow-md z-50 max-h-64 overflow-auto
      ${dropdownPosition === "top"
                      ? "bottom-full mb-1"
                      : "top-full mt-1"
                    }
    `}>
                    <input
                      type="text"
                      autoFocus
                      value={search}
                      onChange={e => setSearch(e.target.value)}
                      placeholder="Search..."
                      className="w-full px-3 py-2 border-b border-gray-200 text-sm outline-none"
                    />

                    <ul className="max-h-52 overflow-auto">
                      {filteredOptions.length === 0 ? (
                        <li className="px-3 py-2 text-gray-400">No results found</li>
                      ) : (
                        filteredOptions.map((option) => (
                          <li
                            key={option.value}
                            onClick={() => {
                              helpers.setValue(option.value);
                              setIsSelectOpen(false);
                            }}
                            className={`px-3 py-2 cursor-pointer text-[#282A3A] hover:bg-gray-100 ${field.value === option.value ? "bg-gray-200" : ""
                              }`}
                          >
                            <div className="truncate">{option.label}</div>
                          </li>
                        ))
                      )}
                    </ul>
                  </div>
                )}
              </div>
            );
          case "checkbox":
            return (
              <div className="flex items-center justify-between w-full pr-2 group cursor-pointer">
                <label className="flex items-center gap-2 cursor-pointer">
                  <Field
                    type="checkbox"
                    name={name}
                    id={name}
                    className={className ? className : checkboxClasses}
                    {...(typeof checked === "boolean" ? { checked } : {})}
                    {...(typeof onChange === "function" ? { onChange } : {})}
                  />
                  <span
                    className={`${className
                      ? className
                      : "text-[6px] md:text-[8px] lg:text-[10px] xl:text-xs 2xl:text-sm text-[#d2d4da]"
                      }`}
                  >
                    {label}
                  </span>
                </label>

                {value && (
                  <div
                    className="relative min-w-[40px] flex-shrink-0 h-full flex items-center justify-end
        px-1 rounded transition-colors duration-200 hover:bg-[#F3F4F8]
      "
                  >
                    <span
                      className="
          absolute right-1 text-blue-500 text-[6px] md:text-[8px] lg:text-[10px] xl:text-xs 2xl:text-sm
          opacity-100 group-hover:opacity-0 transition-opacity duration-200
        "
                    >
                      {value}
                    </span>

                    <button
                      type="button"
                      onClick={onClick}
                      className="
          absolute right-1
          text-blue-500
          text-[6px] md:text-[8px] lg:text-[10px] xl:text-xs 2xl:text-sm
          opacity-0 group-hover:opacity-100
          transition-opacity duration-200
        "
                    >
                      Edit
                    </button>
                  </div>
                )}
              </div>
            );
          case "selectwithnestedcheckbox":
            return (
              <div className="w-full min-w-[250px] relative justify-center items-center">
                <div
                  className={inputClasses1 + " cursor-pointer flex items-center"}
                  onClick={() => setIsSelectOpen(!isSelectOpen)}
                >
                  All
                </div>

                {isSelectOpen && (
                  <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 min-w-[250px] max-h-64 border rounded-md bg-white shadow-[2px_2px_4px_0px_rgba(81,144,222,0.24)] backdrop-blur-sm z-50 overflow-auto">
                    {options.map((opt) => (
                      <div key={opt.value} className="border-b">
                        <div
                          className="flex justify-between items-center p-2 cursor-pointer hover:bg-gray-100"
                          onClick={() =>
                            setOpenCategory((prev) =>
                              prev === opt.value ? null : opt.value,
                            )
                          }
                        >
                          <span>{opt.label}</span>
                          <span>
                            {openCategory === opt.value ? (
                              <FeatherIcon icon="chevron-up" />
                            ) : (
                              <FeatherIcon icon="chevron-down" />
                            )}
                          </span>
                        </div>

                        {/* Nested checkboxes */}
                        {openCategory === opt.value && (
                          <div className="pl-4">
                            {opt.children.map((child) => (
                              <label
                                key={child.value}
                                className="flex items-center gap-2 p-2 cursor-pointer hover:bg-gray-100"
                              >
                                <input
                                  type="checkbox"
                                  checked={field.value?.includes(child.value)}
                                  onChange={() => {
                                    let newValues = field.value || [];
                                    if (newValues.includes(child.value)) {
                                      newValues = newValues.filter(
                                        (c) => c !== child.value,
                                      );
                                    } else {
                                      newValues = [...newValues, child.value];
                                    }
                                    helpers.setValue(newValues);
                                  }}
                                />
                                <span>{child.label}</span>
                              </label>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          case "password":
            return (
              <div className="relative">
                <Field
                  type={showPassword ? "text" : "password"}
                  name={name}
                  id={name}
                  className={inputClasses}
                  autoComplete="current-password"
                />
                <span
                  onClick={togglePasswordVisibility}
                  className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer text-sm text-gray-300"
                >
                  {showPassword ? "Hide" : "Show"}
                </span>
              </div>
            );
          case "radio":
            return (
              <div
                className={`${radioDirection === "horizontal"
                  ? "flex flex-row md:flex-row lg:flex-row xl:flex-row 2xl:flex-row gap-5"
                  : "flex flex-col gap-1 md:gap-1 lg:gap-1 xl:gap-3 2xl:gap-3"
                  } `}
              >
                {options.map((option) => (
                  <div key={option.value} className={`flex items-center`}>
                    <Field
                      type="radio"
                      name={name}
                      id={`${name}-${option.value}`}
                      value={option.value}
                      className={className || radioClasses}
                      onClick={onClick}
                      onChange={onChange}
                      {...props}
                    />
                    <label
                      htmlFor={`${name}-${option.value}`}
                      className={`${labelTextClass} ml-2`}
                    >
                      {option.label}
                    </label>
                    {value && (
                      <div className="relative group inline-block shrink-0 text-right">
                        <span className="text-[6px] md:text-[8px] lg:text-[10px] xl:text-xs 2xl:text-sm text-black group-hover:opacity-0 transition-opacity duration-200">
                          {value}
                        </span>
                      </div>
                    )}
                    {radioDirection === "vertical" && option.count !== undefined && (
                      <span className="ml-auto text-[6px] md:text-[8px] lg:text-[10px] xl:text-xs 2xl:text-sm text-blue-500">
                        {option.count}
                      </span>
                    )}
                  </div>
                ))}
                {meta?.touched && meta?.error ? (
                  <div className="text-red-500 text-xs">{meta.error}</div>
                ) : null}
              </div>
            );
          case "radiobutton":
            return (
              <div
                className={`${radioDirection === "horizontal"
                  ? "flex flex-row gap-3 w-full"
                  : "flex flex-col gap-2 w-full"
                  }`}
              >
                {options.map((option) => {
                  const isSelected = field.value === option.value;

                  return (
                    <label
                      key={option.value}
                      htmlFor={`${name}-${option.value}`}
                      className={`
              flex items-center w-full gap-3 cursor-pointer px-4 py-3 rounded-md transition-all duration-200 select-none

              ${isSelected
                          ? "bg-indigo-200/20 border-0"     // ✔ Selected
                          : "bg-white border border-gray-300"} // ✔ Not selected
            `}
                    >
                      {/* Radio Visual */}
                      <div
                        className={`
                w-5 h-5 rounded-full border flex items-center justify-center
                ${isSelected ? "border-blue-600" : "border-gray-400"}
              `}
                      >
                        {isSelected && (
                          <div className="w-2.5 h-2.5 rounded-full bg-blue-600"></div>
                        )}
                      </div>

                      {/* Hidden Radio Input */}
                      <input
                        type="radio"
                        id={`${name}-${option.value}`}
                        name={name}
                        value={option.value}
                        checked={isSelected}
                        className="hidden"
                        onChange={() => {
                          field.onChange({ target: { name, value: option.value } });
                          onChange &&
                            onChange({ target: { name, value: option.value } });
                        }}
                      />

                      {/* Label Text */}
                      <span
                        className={`text-sm font-medium ${isSelected ? "text-blue-600" : "text-gray-700"
                          }`}
                      >
                        {option.label}
                      </span>
                    </label>
                  );
                })}

                {meta?.touched && meta?.error ? (
                  <div className="text-red-500 text-xs">{meta.error}</div>
                ) : null}
              </div>
            );
          case "textarea":
            return (
              <Field
                as="textarea"
                name={name}
                id={name}
                className={textareaClasses}
                rows={rows}
              />
            );
          case "date":
            return (
              <Field
                type="date"
                name={name}
                id={name}
                min={props.min}
                className={`block w-full pr-0 text-sm ${className}`}
                {...props}
              />
            );
          case "otp":
            const otpValue = field.value || "";

            const handleChange = (e) => {
              let val = e.target.value.replace(/\D/g, "");
              if (val.length > 6) val = val.slice(0, 6);
              helpers.setValue(val);
            };

            const display = otpValue.padEnd(6, "_");
            const firstPart = display.slice(0, 3);
            const lastPart = display.slice(3, 6);

            const renderBox = (chars) => (
              <div className="flex justify-between items-center h-12 w-28 rounded-lg px-3 py-1 bg-indigo-200/20 text-xl font-mono tracking-widest">
                {chars.split("").map((ch, idx) => (
                  <span
                    key={idx}
                    className={ch === "_" ? "text-gray-400" : "text-gray-300"}
                  >
                    {ch}
                  </span>
                ))}
              </div>
            );

            return (
              <div className="relative flex items-center gap-4">
                <input
                  type="text"
                  value={otpValue}
                  onChange={handleChange}
                  maxLength={6}
                  className="absolute inset-0 w-full h-full opacity-0"
                />
                {renderBox(firstPart)}
                <span className="text-xl font-semibold text-white">-</span>
                {renderBox(lastPart)}
              </div>
            );
          default:
            return (
              <Field
                type={type}
                name={name}
                id={name}
                className={inputClasses1 || className}
                placeholder={placeholder}
                autoComplete={type === "email" ? "email" : "off"}
              />
            );
        }
      })()}
      <div className="mt-1 md:mt-1 lg:mt-2 xl:mt-3 2xl:mt-3">
        <ErrorMessage
          name={name}
          component="span"
          className="text-[#ED4337] text-[12px] lg:text-[13px] xl:text-[14px] 2xl:text-[14px]"
        />
      </div>
    </div >
  );
}

export default FormField;

//           case "select":
//             return (
//               <div className="relative" ref={dropdownRef}>
//                 <div
//                   className={`${inputClasses1} flex items-center cursor-pointer py-2`}
//                   onClick={() => setIsSelectOpen(!isSelectOpen)}
//                   role="combobox"
//                   aria-expanded={isSelectOpen}
//                   aria-controls={`${name}-options`}
//                   tabIndex={0}
//                   onKeyDown={(e) => {
//                     if (e.key === "Enter" || e.key === " ") {
//                       e.preventDefault();
//                       setIsSelectOpen(!isSelectOpen);
//                     }
//                   }}
//                 >
//                   <span className="flex-1 truncate">
//                     {options.find((opt) => opt.value === field.value)?.label || ""}
//                   </span>
//                 </div>

//                 {isSelectOpen && (
//                   <ul id={`${name}-options`} role="listbox">
//                     {options.map((option) => (
//                       <li
//                         key={option.value}
//                         onClick={() => {
//                           helpers.setValue(option.value);
//                           setIsSelectOpen(false);
//                         }}
//                         onKeyDown={(e) => handleKeyDown(e, option.value)}
//                         className={`${
//                           field.value === option.value ? "selected" : ""
//                         } ${option.value === "" ? "empty-option" : ""}`}
//                         role="option"
//                         aria-selected={field.value === option.value}
//                         tabIndex={0}
//                       >
//                         {option.label}
//                       </li>
//                     ))}
//                   </ul>
//                 )}

//                 <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
//                   <svg
//                     className={`w-4 h-4 md:w-4 md:h-4 lg:w-5 lg:h-5 xl:w-5 xl:h-5 2xl:w-6 2xl:h-6 text-[#d2d4da] transition-transform duration-200 ${
//                       isSelectOpen ? "rotate-180" : ""
//                     }`}
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth="2"
//                       d="M19 9l-7 7-7-7"
//                     ></path>
//                   </svg>
//                 </div>
//               </div>
//             );
